module.exports = __webpack_public_path__ + "static/icon-74cadaa5f0825a83ce4b9b0e07f3abee.png";